import {setSmoothScroll} from "./general";

document.addEventListener('DOMContentLoaded', () => {
    const collapse = document.querySelectorAll('[data-collapse-target]');

    if (!collapse) return;

    const initializeCollapse = () => {
        collapse.forEach((elem) => {
            const target = elem.dataset.collapseTarget;
            const collapseBody = document.querySelector(target);

            if (!collapseBody) return;

            elem.addEventListener('click', () => {
                if (collapseBody.classList.contains('-open')) {
                    collapseBody.classList.remove('-open');
                    collapseBody.style.maxHeight = null;
                } else {
                    collapseBody.classList.add('-open');
                    setSmoothScroll(target);
                    collapseBody.style.maxHeight = collapseBody.scrollHeight + "px";
                }
            });
        });
    };

    const setCollapseBodyHeight = () => {
        collapse.forEach((elem) => {
            const target = elem.dataset.collapseTarget;
            const collapseBody = document.querySelector(target);

            if (!collapseBody) return;

            if (collapseBody.classList.contains('-open')) {
                collapseBody.style.maxHeight = collapseBody.scrollHeight + "px";
            }
        });
    };

    initializeCollapse();
    window.addEventListener('resize', setCollapseBodyHeight);
});